export default "__VITE_ASSET__d081751c__"